import { render, staticRenderFns } from "./ProjectsMultiselect.vue?vue&type=template&id=4237bcbc"
import script from "./ProjectsMultiselect.vue?vue&type=script&lang=ts"
export * from "./ProjectsMultiselect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4237bcbc')) {
      api.createRecord('4237bcbc', component.options)
    } else {
      api.reload('4237bcbc', component.options)
    }
    module.hot.accept("./ProjectsMultiselect.vue?vue&type=template&id=4237bcbc", function () {
      api.rerender('4237bcbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/ProjectsMultiselect.vue"
export default component.exports